import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LottieIconComponent } from './lottie-icon.component';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';

export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [LottieIconComponent],
  imports: [CommonModule, LottieModule.forRoot({ player: playerFactory })],
  exports: [LottieIconComponent],
})
export class LottieIconModule {}
